import { render, staticRenderFns } from "./income.vue?vue&type=template&id=3ab10690"
import script from "./income.vue?vue&type=script&lang=ts"
export * from "./income.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports